import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    container: {
        backgroundColor: Theme.primaryBackgroundColor,
        height: '100%'
    },
    scrollViewContainer: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    }
};

export default StyleSheet.create(baseStyles);
